import * as React from 'react';
import { makeStyles, createStyles, Typography, Box } from '@material-ui/core';
import { TranquiTheme } from '../../containers/App/theme';
import Btn from '../Btn/Btn';
import Modal from './Modal';
import { useBankContext, useBrandContext } from '../../dictionaries/context/BankContext';
import { BankType, BrandType } from '../../generated/graphql';

export interface ErrorModalProps {
  openModal: boolean;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = (props) => {
  const { onClose, openModal } = props;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const handleClose = (event?: unknown, reason?: 'backdropClick' | 'escapeKeyDown') => {
    if (reason !== 'backdropClick') onClose();
  };

  const [ brand ] = useBrandContext();
  const [ bank ] = useBankContext();
  const modalText = brand === BrandType.Tranquiapp && bank === BankType.BancoDeBogota
    ? (
      <>Te invitamos a leer y aceptar los términos y condiciones del Banco
        {' '} para continuar con la solicitud de tu acuerdo de recuperación de cartera.
      </>
    )
    : (
      <>Revisa que toda la información esté completa y correcta en
        {' '} el formulario antes de enviar tu solicitud al banco.
      </>
    );

  return (
    <Modal
      onClose={handleClose}
      open={openModal}
      maxWidth="sm"
      scroll="paper"
      data-test="cy-missingInformation-modal"
    >
      <Typography className={classes.errorModalTitle}>
        ¡Aún nos hace falta información!
      </Typography>
      <Typography className={classes.errorModalsubitle}>
        {modalText}
      </Typography>
      <Box className={classes.errorModalBox}>
        <Btn
          color="primary"
          variant="contained"
          shadow
          className={classes.errorModalBtn}
          onClick={onClose}
          data-test="cy-closeMissingInformationModal-btn"
        >
          Continuar
        </Btn>
      </Box>
    </Modal>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  errorModalTitle: {
    ...theme.typography.h6,
    fontWeight: 600,
    color: theme.palette.indigo.main,
    marginBottom: theme.spacing(1),
  },
  errorModalsubitle: {
    ...theme.typography.body1,
    color: theme.palette.text4.main,
  },
  errorModalBtn: {
    marginTop: theme.spacing(2),
  },
  errorModalBox: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default ErrorModal;
